import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DmComboDataComponent } from 'src/app/components/combo/dm-combo-data/dm-combo-data.component';
import { DmComboComponent } from 'src/app/components/combo/dm-combo/dm-combo.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


@NgModule({
  declarations: [
    DmComboDataComponent,
    DmComboComponent
  ],
  exports: [  
    DmComboDataComponent, 
    DmComboComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule  
  ]
})
export class ComboModule { }
